<template>
	<button
		class="close-button"
		:name="name"
		:aria-label="$t('closeModal')"
		role="button"
		@mousedown.prevent
	>
		<svgicon name="modal-close"></svgicon>
	</button>
</template>
<script>
import '../icons/modal-close';
export default {
	props: {
		name: {
			type: String,
			required: true
		}
	}
};
</script>
<style lang="scss" scoped>
.close-button {
	position: absolute;
	height: 32px;
	width: 32px;
	border-radius: 100%;
	padding: 8px;
	right: 16px;
	top: 16px;
	border: 0;
	color: $font-blue;
	background-color: $container-bgcolor;
	@media (any-hover: hover) {
		&:hover {
			cursor: pointer;
			svg {
				fill: $hover-state;
			}
		}
	}

	&:active {
		svg {
			fill: $tapped-state;
		}
	}
	svg {
		fill: $primary-state;
	}
}
</style>
